import { render, staticRenderFns } from "./NewTransactionBienForm.vue?vue&type=template&id=2ce4b86a&scoped=true"
import script from "./NewTransactionBienForm.vue?vue&type=script&lang=js"
export * from "./NewTransactionBienForm.vue?vue&type=script&lang=js"
import style0 from "./NewTransactionBienForm.vue?vue&type=style&index=0&id=2ce4b86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce4b86a",
  null
  
)

export default component.exports